import { useTranslation } from '@crehana/i18n';
import { CustomNextImage as Image } from '@crehana/next';
import TextLink from '@crehana/ui/dist/Buttons/TextLink';

import type { Coupon } from '../../types';
import CouponCode from '../CouponCode/CouponCode';

const CouponCard: React.FC<React.PropsWithChildren<{ coupon: Coupon }>> = ({
  coupon,
}) => {
  const { t } = useTranslation();

  return (
    <article className="flex flex-col items-center">
      <div className="w-full relative flex items-center">
        <div className="w-full h-auto">
          <Image
            alt="Cupón"
            src={coupon.image}
            loader={({ src }) => src}
            layout="responsive"
            width={500}
            height={300}
          />
        </div>
        <p
          css={`
            @media (min-width: 1024px) {
              font-size: 68px !important;
            }
          `}
          className="text-right text-white font-main-title-md absolute ml-16 sm:ml-32"
        >
          {coupon.percentageOff}% <br /> off.
        </p>
      </div>
      <div
        className="px-16 pt-16 md:pt-24 pb-16 md:px-24 sm:pb-24 w-full"
        css={`
          border-left: 1px solid #e8eaf0;
          border-bottom: 1px solid #e8eaf0;
          border-right: 1px solid #e8eaf0;
        `}
      >
        <div>
          <h3 className="font-subtitle2-md md:hidden">{coupon.title}</h3>
          <h3 className="font-subtitle1-md hidden md:block">{coupon.title}</h3>
        </div>
        <p className="font-body4 mt-8 text-gray-dark">{coupon.description}</p>
        <CouponCode code={coupon.code} />
        <div className="text-center mt-16 md:mt-24">
          <TextLink
            onClick={() => {
              window.location.href = coupon.productUrl!;
            }}
            label={t('COUPONS_SECTION_APPLY_LABEL', 'Aplícalo aquí')}
            css={`
              @media (min-width: 768px) {
                font-size: 18px !important;
                line-height: 20px !important;
              }
            `}
            className=" text-center font-link text-secondary-main"
          />
        </div>
      </div>
    </article>
  );
};

export default CouponCard;
